import React, { Component } from "react";
import PropTypes from "prop-types";
import List from "@material-ui/core/List";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { withStyles } from "@material-ui/core/styles";
import ItemRework from "../list-item/ItemRework";
import CreateRework from "./CreateRework";
import "@mdi/font/css/materialdesignicons.min.css";
import axios, { contentClient } from "../../AxiosClient";
import PubSub from "pubsub-js";
import { REWORK_ADD } from "../../utils/Topics";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { withTranslation, Trans } from "react-i18next";
import FilterListIcon from "@material-ui/icons/FilterList";
import Skeleton from "@material-ui/lab/Skeleton";
import { withSnackbar } from "notistack";
import { Virtuoso } from "react-virtuoso";
import FilterWrapper from "../filter/FilterWrapper";

const styles = (theme) => ({
  badge: {
    display: "flex",
    height: "50%",
  },
  cardActionWithoutFilter: {
    // flex: "1 1",
  },
  cardAction: {
    flex: "1 1 50%",
    flexDirection: "row",
  },
});
export class SidebarRework extends Component {
  static propTypes = {
    documentId: PropTypes.number.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      selectedView: 1,
      instance: new Date().getTime().toString(),
      createReworkOpen: false,
      viewRework: false,
      reworks: [],
      index: 0,
      resolvingReworks: [],
      loading: true,
      page: 0,
      isAtEnd: false,
      pageSize: 20,
      filters: {
        status: "OPEN",
        sort: "urgency",
        sortOrder: "DESC",
        urgency: "All",
        authoredByMe: false,
        raisedByMe: false,
        taxonomyId: 0,
        knowledgeSourceId: 0,
        documentId: 1,
        includeUnattached: true,
        taxonomyNode: { name: "" },
      },
      showFilters: false,
      filterAnchorEl: null,
    };
    this.changeOpenCreateRework = this.changeOpenCreateRework.bind(this);
    this.onItemClick = this.onItemClick.bind(this);
    this.textInput = React.createRef();
    this.addRework = this.addRework.bind(this);
  }

  componentDidMount() {
    this.token = PubSub.subscribe(REWORK_ADD, this.subscriber);
    this.getDocumentRework();
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.token);
  }

  subscriber = (data) => {
    let array = this.state.reworks.slice(0);
    array.unshift(data.data);
    this.setState({ reworks: array });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.filter) {
      if (this.props.filter !== prevProps.filter) {
        this.setState({isAtEnd: false, page: 0}, () => {
          this.getDocumentRework()
        })
      }
    }
    if (this.state.resolvingReworks !== prevState.resolvingReworks) {
      this.props.onResolvingReworksChange &&
        this.props.onResolvingReworksChange(this.state.resolvingReworks);
    }
  }

  toggleFilters = (e) => {
    this.state.filterAnchorEl === null &&
      this.setState({ filterAnchorEl: e.currentTarget });
    this.setState((prev) => ({ showFilters: !prev.showFilters }));
  };
  onFilterChange = (filter) => {
    this.props.onFilterChange 
      ? this.props.onFilterChange()
      : this.setState({
          filters: filter,
          isAtEnd: false,
          page: 0,
        }, () => {this.getDocumentRework()});
  };
  reworkRowRenderer = (idx) => {
    const rework = this.state.reworks[idx];
    if (!rework) {
      return <div key={idx} style={{ height: 1 }} />;
    } else {
      return (
        <ItemRework
          key={idx}
          onItemClick={this.onItemClick}
          isPortlet={this.props.isPortlet}
          documentSidebar={true}
          onReject={this.onReworkReject}
          // fullscreen={this.props.fullscreen}
          data={rework}
          onResolveChange={this.onReworkResolveChange(
            rework
          )}
          editing={this.props.editing}
        />
      )
    }

  
  };
  render() {
    const { classes, t } = this.props;

    return (
      <>
        {this.props.show && (
          <>
            <CardHeader
              titleTypographyProps={{ component: "h3" }}
              title={t("document_sidebar_rework_requests")}
              classes={
                (this.props.fullscreen || this.state.fullwidth)
                  ? {
                      action: classes.cardAction,
                    }
                  : {
                      action: classes.cardActionWithoutFilter,
                    }
              }
              action={
                <>

                {this.props.fullscreen ?
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <FilterWrapper
                          disablePortal
                          open={true}
                          onClose={this.toggleFilters}
                          anchorEl={this.state.filterAnchorEl}
                          filterElement="FilterRework"
                          filter={this.state.filters}
                          onFilterChange={this.onFilterChange}
                          isFilterBar={true}
                          title={this.props.t("rework_filter_title")}
                        />
                      </div>
                    </div>
                    : this.props.toggleSidebar && (
                    <IconButton
                      onClick={this.props.toggleFilters}
                      aria-label={t("global_filter global_rework_plural")}
                    >
                      <FilterListIcon />
                    </IconButton>
                  )}
                  {this.props.toggleSidebar &&
                    !this.props.hideCloseButton && (
                      <IconButton
                        onClick={this.props.toggleSidebar}
                        aria-label="Close sidebar"
                      >
                        <CloseIcon />
                      </IconButton>
                    )}
                </>
              }
            />
            <CardContent
              style={{
                height: this.props.editing ? "50%" : "100%",
                maxHeight: "calc(100% - 180px)",
                // overflow: "auto",
                display: "flex",
                flexDirection:"column",
              }}
            >
              {this.props.editing && (
                <div>
                  <Typography>
                    {t("document_sidebar_rework_editing_select")}
                  </Typography>
                </div>
              )}
              <div style={{ flex: "1 1 auto", display: "flex"}}>
                <div style={{ flex: "1 1 auto", display: "flex"}}>
                  {/* <List> */}
                    {this.state.loading ? (
                      <>
                        <div>
                          {Array.from(Array(5)).map(() => {
                            return (
                              <div style={{ marginTop: 4, marginBottom: 12 }}>
                                <Skeleton
                                  variant="rect"
                                  style={{ width: "35%", marginBottom: 5 }}
                                  height={25}
                                  animation="wave"
                                />
                                <Skeleton
                                  variant="rect"
                                  style={{ width: "90%" }}
                                  height={25}
                                  animation="wave"
                                />
                              </div>
                            );
                          })}
                        </div>
                      </>
                    ) : (
                      <>
                        {this.state.reworks && this.state.reworks.length > 0 &&
                          <Virtuoso
                            overscan={10}
                            totalCount={this.state.reworks ? this.state.reworks.length : 0}
                            itemContent={(idx) => this.reworkRowRenderer(idx)}
                            defaultItemHeight={63}
                            endReached={(idx) => {
                              this.getDocumentRework();
                            }}
                            style={{ width: "100%",  height: "100%", minHeight: "400px"  }}
                          />
                          }
                      </>
                    )}
                  {/* </List> */}
                  {!this.state.loading &&
                    (!this.state.reworks ||
                      (this.state.reworks.length === 0 && (
                        <div>
                        <Typography style={{ width: "100%"}}>
                          {t("document_sidebar_rework_no_reworks")}
                        </Typography>
                        </div>
                      )))}
                </div>

                {!this.props.hideFab && (
                  <Fab
                    id="open-create-rework-dialog"
                    ref={this.textInput}
                    onClick={this.changeOpenCreateRework}
                    color="primary"
                    aria-label="Create rework"
                    style={{
                      position: "absolute",
                      bottom: 65,
                      right: 20,
                      zIndex: 9999999999,
                    }}
                  >
                    <AddIcon />
                  </Fab>
                )}
              </div>
            </CardContent>
            <FilterWrapper
              asPopper
              disablePortal
              open={this.state.showFilters}
              onClose={this.toggleFilters}
              anchorEl={this.state.filterAnchorEl}
              filterElement="FilterRework"
              filter={this.props.filter ? this.props.filter : this.state.filters}
              onFilterChange={this.onFilterChange}
              isFilterBar={true}
              title={this.props.t("rework_filter_title")}
            />
          </>
        )}
        {this.state.createReworkOpen && (
          <CreateRework
            addRework={this.addRework}
            propsRef={this.textInput}
            instance={this.state.instance}
            open={this.state.createReworkOpen}
            changeOpenCreateRework={this.changeOpenCreateRework}
            revisionId={this.props.internalDocument.contentRVO.revisionId}
            isDraft={this.props.isDraft}
          />
        )}
      </>
    );
  }
  onReworkResolveChange = (rework) => (resolving) => {
    let resolvingReworks = [...this.state.resolvingReworks];
    let idx = resolvingReworks.indexOf(rework.id);
    if (resolving) {
      if (idx === -1) {
        resolvingReworks.push(rework.id);
      }
    } else {
      if (idx > -1) {
        resolvingReworks.splice(idx, 1);
      }
    }
    this.setState({ resolvingReworks });
    this.props.updateResolvingReworks(resolvingReworks);
  };

  onReworkReject = (rework) => {
    let reworks = [...this.state.reworks];
    reworks = reworks.map((r) => {
      if (r.id === rework.id) return rework;
      return r;
    });
    this.setState({ reworks });
  };

  showReworkList = () => {
    this.setState({
      viewRework: !this.state.viewRework,
    });
  };
  onItemClick = (rework) => {};
  addRework = (rework) => {
    this.props.enqueueSnackbar(
      this.props.t("document_sidebar_rework_snack_raised"),
      {
        variant: "success",
      }
    );
    let newRework = [...this.state.reworks];
    newRework.push(rework);
    this.setState({ reworks: newRework });
  };
  getDocumentRework = () => {
    if (this.state.isAtEnd) return;
    //if we are calling this from a DocumentSidebar then the filter has to be in the parent object because it
    //will otherwise not be fully visible.  if fullscreen prop is set then we want to manage the filter locally
    //using state
    let filters = this.props.filter ? this.props.filter : this.state.filters
    contentClient
      .post(`/rework/filter?page=${this.state.page}&size=${this.state.pageSize}`, {
        knowledgeItemId: this.props.internalDocument.contentRVO.itemId,
        ...filters,
      })
      .then((res) => {
        if (res.data.number === 0) {
          this.setState({
            reworks: res.data.content,
            loading: false,
          });
        } else {
          this.setState({ reworks: [...this.state.reworks, ...res.data.content], loading: false });
        }
        if (res.data.last) {
          this.setState({ isAtEnd: true })
        } else {
          this.setState({ page: this.state.page + 1});
        }
      });
  };

  changeOpenCreateRework = () => {
    this.setState({
      createReworkOpen: !this.state.createReworkOpen,
    });
  };
}
export default withStyles(styles)(
  withTranslation()(withSnackbar(SidebarRework))
);
